$(document).ready(function() {
    function setDesktopDefault() {
        var width = $(window).width();
        if (width > 639) {
            $(".section-name").addClass("active");
            $(".top-level").css("max-height", "100%");
        } else {
            // Reset to allow toggle functionality on mobile
            $(".section-name").removeClass("active");
            $(".top-level").css("max-height", "0px");
        }
    }

    // Set default state on load
    setDesktopDefault();

    // Update on window resize
    $(window).on("resize", function() {
        setDesktopDefault();
    });

    // Toggle functionality for mobile only
    $(".section-name").on("click", function() {
        var width = $(window).width();
        if (width < 639) {
            $(this).toggleClass("active");
            $(".top-level").css("max-height", $(this).hasClass("active") ? "100%" : "0px");
        }
    });
});